import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ProfessionalDialog" })
export default class ProfessionalDialog extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;
    public professionalLaw: string = null;

    @Prop() readonly isEnabled: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (this.isEnabled) {
            let cookie = CookieHelper.getCookie("pro");
            if (!cookie) {
                this.isVisible = true;
            }
        }

        if (!this.professionalLaw) {
            let response = await Axios.post(this.routes.Terms_GetProfessionalLaw);

            this.professionalLaw = Object.freeze(response.data.description);
        }
    }

    public mounted() {
        if (this.isVisible) {
            this.$nextTick(function () {
                document.querySelector("#app").classList.add("overflow");
            });
        }
    }

    public setIsProfessional() {
        CookieHelper.setCookie("pro", "pro", 7);
        this.isVisible = false;
        document.querySelector("#app").classList.remove("overflow");
    }

    public setIsNotProfessional() {
        window.location.href = this.routes.Customer_CustomerHome;
    }
}
